export const LOCALOPS_TASK_PAYMENT_MODES = Object.freeze({
  PAID: 'paid',
  COMMUNITY: 'community',
});

export const LOCALOPS_COMMUNITY_TASK_ROLE = 'communityTaskAdmin';

export function normalizeLocalOpsRegionSlug(value, fallback = '') {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return normalized || fallback;
}

export function normalizeTaskPaymentMode(value) {
  return String(value || '').trim().toLowerCase() ===
    LOCALOPS_TASK_PAYMENT_MODES.COMMUNITY
    ? LOCALOPS_TASK_PAYMENT_MODES.COMMUNITY
    : LOCALOPS_TASK_PAYMENT_MODES.PAID;
}

export function isCommunityTask(task) {
  return normalizeTaskPaymentMode(task?.paymentMode) ===
    LOCALOPS_TASK_PAYMENT_MODES.COMMUNITY;
}

export function getLocalOpsPlayerRecord(player) {
  return player?.data?.player || player?.player || player || null;
}

export function getActiveLocalOpsRoleGrant(player, role, regionSlug = 'camden') {
  const record = getLocalOpsPlayerRecord(player);
  if (!record) return null;
  const normalizedRole = String(role || '').trim();
  const normalizedRegion = normalizeLocalOpsRegionSlug(regionSlug, 'camden');
  const grants = Array.isArray(record.localOpsRoles) ? record.localOpsRoles : [];
  return (
    grants.find(
      (grant) =>
        grant?.role === normalizedRole &&
        String(grant?.status || 'active').trim() === 'active' &&
        normalizeLocalOpsRegionSlug(grant?.regionSlug) === normalizedRegion,
    ) || null
  );
}

export function canCreateCommunityTask(player, regionSlug = 'camden') {
  const record = getLocalOpsPlayerRecord(player);
  if (!record) return false;
  if (String(record.role || '').trim() === 'admin') return true;
  return !!getActiveLocalOpsRoleGrant(
    record,
    LOCALOPS_COMMUNITY_TASK_ROLE,
    regionSlug,
  );
}
